import { CAMERA } from "../apiConstant";
import BaseApi from "../baseApi";

class CameraApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_SFU_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  /* sfu */
  getRtpCapabilities(param) {
    return this.post(`${CAMERA}/get-rtpCapabilities`, param);
  }

  createProducerTransport(param) {
    return this.post(`${CAMERA}/create-producer-transport`, param);
  }

  createConsumerTransport(param) {
    return this.post(`${CAMERA}/create-consumer-transport`, param);
  }

  connectTransport(param) {
    return this.post(`${CAMERA}/connect-transport`, param);
  }

  produce(param) {
    return this.post(`${CAMERA}/produce`, param);
  }

  consume(param) {
    return this.post(`${CAMERA}/consume`, param);
  }

  resume(param) {
    return this.post(`${CAMERA}/resume`, param);
  }

  leave(param) {
    return this.post(`${CAMERA}/leave`, param);
  }

  closeProducer(param) {
    return this.post(`${CAMERA}/close-producer`, param);
  }
}

export default CameraApi;
